class GamePads {
  constructor(config = {}) {
    this.controllers = []
    this.setMaps()
    this.padMap = config.padMap ? config.padMap : this.defaultMap
    this.pressMap = config.pressMap ? config.pressMap : {}
    this.oldPressMap = {}
    this.deadZone = config.deadZone ? config.deadZone : 0.3
  }

  update() {
    this.scanGamePads()
    Object.assign(this.oldPressMap, this.pressMap)
    let temp = this.pressMap
    for (let p in temp) {
      temp[p] = 0
    }

    for (let conIndex = 0; conIndex < this.controllers.length; conIndex++) {
      let controller = this.controllers[conIndex]
      if (!controller) {
        continue
      }
      for (let i = 0; i < controller.buttons.length; i++) {
        let keyCode = this.padMap.buttons[i]
        // console.log(keyCode, 'keyCode')
        if (keyCode) {
          let padBtn = controller.buttons[i]
          this.pressMap[keyCode] = padBtn.pressed
            ? padBtn.value
            : this.pressMap[keyCode]
        }
      }

      for (let i = 0; i < controller.axes.length; i++) {
        if (!this.padMap.axes) {
          return
        }
        if (this.padMap.axes[i]) {
          let value = controller.axes[i]
          if (Math.abs(value) > this.deadZone) {
            let sign = value > 0 ? 1 : -1
            this.pressMap[this.padMap.axes[i]] =
              (Math.abs(controller.axes[i]) - this.deadZone) * sign
          }
        }
      }
    }
  }

  scanGamePads() {
    let gamepads = navigator.getGamepads()
    // console.log(gamepads)
    for (let i = 0; i < gamepads.length; i++) {
      if (gamepads[i]) {
        if (!(gamepads[i].index in this.controllers)) {
          this.addgamepad(gamepads[i])
        } else {
          this.controllers[gamepads[i].index] = gamepads[i]
        }
      }
    }
  }

  addgamepad(gamepad) {
    this.controllers[gamepad.index] = gamepad
  }

  justPressed(key) {
    if (this.pressMap[key] && !this.oldPressMap[key]) {
      return this.pressMap[key]
    } else {
      return 0
    }
  }

  pressed(key) {
    return this.pressMap[key]
  }

  justRelesed(key) {
    return !this.pressMap[key] && this.oldPressMap[key]
  }

  noOtherPressed(key) {
    for (let p in this.pressMap) {
      if (this.pressMap[p] && p !== key) {
        return false
      }
    }
    return true
  }

  setMaps() {
    this.defaultMap = {
      buttons: {
        0: 'A',
        1: 'B',
        2: 'X',
        3: 'Y',
        4: 'LB',
        5: 'RB',
        6: 'LT',
        7: 'RT',
        8: 'BACK',
        9: 'START',
        10: 'LSTICK',
        11: 'RSTICK',
        12: 'UP',
        13: 'DOWN',
        14: 'LEFT',
        15: 'RIGHT',
        16: 'SWITCH',
      },
      axes: {
        0: 'ALX',
        1: 'ALY',
        2: 'ARX',
        3: 'ARY',
      },
    }

    this.axesEffect = {
      ALX: 0,
      ALY: 1,
      ARX: 2,
      ARY: 3,
    }
  }
}
window.GamePads = GamePads

export default GamePads

// window.gamePad = new GamePads()

// function update() {
//     if (window.gamePad) window.gamePad.update()
//     window.requestAnimationFrame(() => {
//         update()
//     })
// }

// update()
